import { StyleSheet } from 'aphrodite';
import DIMENSIONS from '../../library/dimensions';

const styles = StyleSheet.create({
  root: {
    height: '600px',
    width: DIMENSIONS.contentWidth
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/map/map-styles.js